/* eslint-disable jsx-a11y/media-has-caption */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { Button } from "gatsby-material-ui-components";
import formatTitle from "../common/formatTitle";
import FlecheDLongue from "./fleche_d_longue.svg";
import FlecheDCourte from "./fleche_d_courte.svg";
import FlecheGLongue from "./fleche_g_longue.svg";
import FlecheGCourte from "./fleche_g_courte.svg";
import LineVert from "./line_vert.svg";
import Tem1 from "./temoignage1.png";
import Tem2 from "./temoignage2.png";
import Tem3 from "./temoignage3.png";
import Img from "gatsby-image";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  regularRow: {
    padding: theme.layout.paddingRegular,
    marginBottom: 50,
  },
  enLight: {
    color: theme.palette.primary.light,
  },
  centered: {
    textAlign: "center",
  },
  titreDesktop: {
    color: "#FFF",
    fontWeight: 1000,
  },
  desktopButtons: {
    position: "absolute",
    width: "150px",
    height: "61px",
    backgroundColor: theme.palette.primary.light,
    bottom: 0,
    left: -150,
    borderTopLeftRadius: 10,
    borderBottomLeftRadius: 10,
  },
  desktopBtn: {
    backgroundColor: "transparent",
    height: 61,
  },
  desktopContents: {
    position: "absolute",
    right: 0,
    bottom: -40,
    backgroundColor: "#1F3598",
    width: "65%",
    height: 320,
    color: "#FFF",
    padding: theme.spacing(4),
    textAlign: "left",
  },
}));

const images = [Tem1, Tem2, Tem3];
const Temoignage = ({ title, items, images: imagesM, matches }) => {
  const classes = useStyles();
  const [index, setIndex] = useState(0);
  const [active, setActive] = useState(false);
  const theme = useTheme();

  useEffect(() => {
    setTimeout(() => setActive(true), 1000);
  }, []);

  const handleBack = () => setIndex(index === 0 ? 1 : index - 1);
  const handleFwd = () => setIndex(index === index.length - 1 ? 0 : index + 1);

  return (
    <Grid
      item
      className={classes.regularRow}
      container
      direction="column"
      spacing={matches ? 4 : 1}
    >
      <Grid item>
        <Typography variant="h1" className={classes.centered}>
          {formatTitle(title)}
        </Typography>
      </Grid>
      <Grid
        item
        style={{ position: "relative", textAlign: matches ? "left" : "center" }}
      >
        {matches ? (
          <img
            src={images[index]}
            height="413px"
            width="auto"
            alt="temoignage"
          />
        ) : (
          <Img fixed={imagesM[index]} height="133px" width="auto" fadeIn />
        )}
        <div className={clsx({ [classes.desktopContents]: matches })}>
          <Typography
            variant="h6"
            className={clsx({
              [classes.titreDesktop]: matches,
              [classes.titreMobile]: !matches,
            })}
          >
            {items[index].name}
          </Typography>
          {matches && <hr style={{ maxWidth: "80px", margin: "5px 0" }} />}
          <Typography variant="body2">{items[index].position}</Typography>
          <Typography
            variant="body1"
            style={{ textAlign: "left", minHeight: matches ? "" : 220 }}
          >{`“${items[index].content}”`}</Typography>
          <div className={clsx({ [classes.desktopButtons]: matches })}>
            <Grid
              container
              direction="row"
              alignItems="center"
              justify="space-between"
              spacing={!matches ? 2 : 0}
            >
              <Grid item xs={!matches ? 6 : 5}>
                <Button
                  className={clsx({ [classes.desktopBtn]: matches })}
                  style={
                    matches
                      ? {
                          backgroundColor: "transparent",
                        }
                      : {}
                  }
                  fullWidth
                  disabled={index === 0}
                  onClick={handleBack}
                  color={matches ? "inherit" : "primary"}
                  variant="contained"
                >
                  {matches ? <img src={FlecheGCourte} alt="précédent" /> : "<"}
                </Button>
              </Grid>
              {matches && (
                <Grid item xs={2} style={{ textAlign: "center" }}>
                  <img src={LineVert} alt="|" />
                </Grid>
              )}
              <Grid item xs={!matches ? 6 : 5}>
                <Button
                  className={clsx({ [classes.desktopBtn]: matches })}
                  style={
                    matches
                      ? {
                          backgroundColor: "transparent",
                        }
                      : {}
                  }
                  fullWidth
                  onClick={handleFwd}
                  disabled={index === items.length - 1}
                  color={matches ? "inherit" : "primary"}
                  variant="contained"
                >
                  {matches ? <img src={FlecheDCourte} alt="suivant" /> : ">"}
                </Button>
              </Grid>
            </Grid>
          </div>
        </div>
      </Grid>
    </Grid>
  );
};

Temoignage.defaultProps = {
  images: PropTypes.array.isRequired,
};

export default Temoignage;
